<template>
  <component :is="activeTourComponent" />
</template>

<script setup lang="ts">
import { useTourStore } from '@/core/store/tour';

const { activeTourComponent } = useTourStore();
</script>

<style scoped lang="scss"></style>
